import { schema } from 'normalizr';

import { processDelegationRequest } from '../strategies/delegationRequest';

import { userSchema } from './user';

export const delegationRequestSchema = new schema.Entity(
  'delegationRequests',
  {
    userId: userSchema,
  },
  {
    processStrategy: processDelegationRequest,
  }
);
